import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Helmet from 'react-helmet';

import styled from 'styled-components'
import cssVar from '../styles/variables'
import { FullSizeBackgroundVideo, SlimSection, SectionHeading, Select, Heading4, LinkText, FullAreaWrapper, PrimaryButton, SecondaryButton, Text, Link, withColor, Heading2, Heading3, BiggerText, H1, GridRow, FullWidthWrapper, Section, FullWidthSection, HeroSection, Heading1, MaxContentWidthContainer, MaxContentWidthWrapper } from '../components/marketing/MarketingStyles';

import RequestInformation from '../components/marketing/RequestInformationSection'
import CtaBox from '../components/marketing/CtaBox'
import GolfCourseList from '../components/marketing/GolfCourseList'
import Features from '../components/marketing/FeatureSection'
import LimitedAccess from '../components/marketing/LimitedAccessSection'
import RequestPhoneCall from '../components/marketing/RequestPhoneCallSection'
import QandA from '../components/marketing/QandASection'
import Pricing from '../components/marketing/PricingSection'
import GolfCourseMap from '../components/marketing/GolfCourseMap'

import Logo from '../images/logo.svg'
import FlyOverArrow from '../images/icons/arrow-flyover.png'
import DiscoverMoreArrow from '../images/icons/arrow-discover-more.svg'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import { trackEvent } from "../utils/eventTracking"

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
  }

  componentDidUpdate() {
  }

  componentDidMount() {
    if(this.props.history.location.hash == "#features") {
      // window.scroll(0, 1000)
      window.scrollTo(0, this.startOfPage.offsetTop)
      this.props.history.push("/details-zur-plattform")
      setTimeout(() => {
        this.startOfPage.scrollIntoView()
        window.scrollTo(0, this.startOfPage.offsetTop)
      }, 4000);
    }
  }

  render() {

    const Hero = ( ) => (
      <HeroSection>
        <FullSizeBackgroundVideo>
          <video loop="true" autoPlay="true" muted="true" playsInline="true">
            <source src="https://the-loge-data.fra1.digitaloceanspaces.com/marketing/videos/Hero-Section-Video-sales.mp4" type="video/mp4" />
          </video>
        </FullSizeBackgroundVideo>
        <MaxContentWidthWrapper style={{height: '100%'}}>
          <MaxContentWidthContainer style={{height: '100%'}}>
            <GridRow
              desktop="1fr 1fr 1fr"
              tablet="1fr"
              phone="1fr"
              style={{height: '100%'}}
            >
              <HeroContentWrapper>
                <H1 color="#FFFFFF">Business.<br/>Golf.<br/>Network.</H1>
                <HeroText>
                  Das größte Golfnetzwerk einer neuen Generation von Unternehmern.
                </HeroText>
                <div>
                  <PrimaryButton value="Jetzt bewerben" onClick={ e => { e.preventDefault(); this.props.history.push('/bewerbung'); trackEvent( 'Apply - Detail - Hero Section', 'Application', 'Click Button' ) }} autoWidth />
                </div>
              </HeroContentWrapper>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>
        <ScrollHint onClick={ () => this.startOfPage.scrollIntoView()}>
          <ScrollHintText>Vorteile Entdecken</ScrollHintText>
          <ScrollHintIcon src={ DiscoverMoreArrow } />
        </ScrollHint>
      </HeroSection>
    )

    const Spotlight = ( ) => (
      <Section>
        Spotlight
      </Section>
    )

    const BookAppointmentSection = ( ) => (
      <SlimSection>
        <CtaBox
          title="Jetzt Termin vereinbaren"
          text="Vereinbaren Sie einen persönlichen Gesprächstermin mit einem unserer Geschäftsführer."
          buttonText="Jetzt Termin vereinbaren"
          buttonLink="make_appointment_target"
          onClick={ () => trackEvent( 'Arrange Meeting - Details - CTA Section', 'Meeting', 'Click Button' )}
        />
      </SlimSection>
    )

    const GolfCourseMapSection = ( ) => (
      <GolfCourseMapWrapper>
        <GolfCourseMap showPanel />
      </GolfCourseMapWrapper>
    )

    const ApplyCTA = ( ) => (
      <SlimSection>
        <CtaBox
          title="Jetzt Bewerbung starten"
          text="Jetzt die Bewerbung starten und in ein einzigartiges Netzwerk tauchen."
          buttonText="Jetzt Bewerben"
          buttonLink="/bewerbung"
          onClick={ () => trackEvent( 'Apply - Footer - CTA Section', 'Application', 'Click Button' )}
        />
      </SlimSection>
    )

    const metaData = [
      { name: 'description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'og:title', content: "Details zur Plattform | THE LOGE" },
      { property: 'twitter:title', content: "Details zur Plattform | THE LOGE" },
      { property: 'og:description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'twitter:description', content: "THE LOGE bietet die größte Netzwerkplattform für golfaffine Unternehmen in Österreich | berwerben Sie sich jetzt" },
      { property: 'og:image', content: "https://images.unsplash.com/photo-1433800881591-a31e7bff3f22?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80" },
      { property: 'twitter:image', content: "https://images.unsplash.com/photo-1433800881591-a31e7bff3f22?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1350&q=80" },
    ]

    return (
      <FullWidthWrapper>
        <Helmet meta={ metaData } />
        <Hero />
        <div ref={ (ref) => this.startOfPage=ref } id="#features"></div>
        <Features />
        <LimitedAccess />
        {/* <Spotlight />  */} { /* TODO add when we have content */ }
        <BookAppointmentSection />
        <GolfCourseMapSection />
        {/* <GolfCourseList /> */}
        <Pricing />
        {/* <RequestInformation /> */}
        <RequestPhoneCall />
        <QandA />
        <ApplyCTA />
      </FullWidthWrapper>
    )
  }
}

export default withRouter(Home)

const GreyText = withColor(Text, cssVar.colors.grey)
const GreyLink = withColor(Link, cssVar.colors.grey)

const GolfCourseMapWrapper = styled(FullWidthSection) `
  height: 800px;

  ${cssVar.breakpoints.tablet} {
    height: auto;
  }
`

const HeroContentWrapper = styled(FullAreaWrapper) `
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
`

const HeroText = styled(Text) `
  padding: 40px 0;
  color: white;
`

const ScrollHint = styled.div `
  padding: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 20px;
  transition: all ${ cssVar.transitions.basic };
  text-decoration: none;

  :hover {
    transform: translate(-50%, -20px);
    text-decoration: none;
  }

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`

const ScrollHintText = styled(LinkText) `
  color: ${ cssVar.colors.gold }
`

const ScrollHintIcon = styled.img `
  padding: 0;
`



// WEBPACK FOOTER //
// /src/pages/Information.js